import { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useResetAtom } from "jotai/utils";
import { Avatar, Divider } from "antd";

import styles from "./headerCard.module.css";
import { Button } from "../../../customs";
import { logout, userAtom } from "../../../utils/store";
import { ReactComponent as SignOutIcon } from "../../../assets/svgs/sign-out.svg";
import { useSetAtom } from "jotai";

interface ComponentProps {
  firstName: string;
  profilePicture: string;
}

const HeaderCard: FC<ComponentProps> = ({ firstName, profilePicture }) => {
  const resetUser = useResetAtom(userAtom);
  const setUser = useSetAtom(userAtom);

  const navigate = useNavigate();

  const handleLogOut = () => {
    resetUser();

    setUser({
      Token: "",
      MemberId: "",
      Expiration: "",
      AccountType: null,
      Role: [],
      IsNewApplicant: false,
      MembershipTypeId: 0,
      Email: null,
      ApplicantId: "",
      ExemptionId: 0,
      StartDate: "",
      EndDate: null,
      HasPaidExemptionFee: false,
      IsOldStudent: false,
    });

    logout();

    navigate("/");
  };

  return (
    <div className={styles.container}>
      <div>
        <Avatar src={profilePicture} size={60} />

        <div>
          <h3>{firstName}</h3>

          <Link to="/profile">
            <p>View Profile</p>
          </Link>
        </div>
      </div>

      <Divider className={styles.divider} />

      <Button variant="naked" color="#67686D" onClick={handleLogOut}>
        <div className={styles.buttonWrapper}>
          <SignOutIcon />

          <p>Log Out</p>
        </div>
      </Button>
    </div>
  );
};

export default HeaderCard;
